import React, { PureComponent } from 'react';
import { withRouter } from 'react-router-dom';
import renderEnvComponent from 'data/common/renderEnvComponent';
import FormPushNotification from './Form/FormPushNotification';
import { getPushNotificationDetails, updatePushNotification, sendPushNotificationEvent } from '../../data/PushNotifications/actions';

class PushNotificationDetails extends PureComponent {
    render() {
        return (
            <FormPushNotification
                type="update"
                sendDataFunc={updatePushNotification}
                sendEventFunc={sendPushNotificationEvent}
                getDetailsFunc={getPushNotificationDetails}
            />
        );
    }
}

export default withRouter(renderEnvComponent('scenes/PushNotification/details', PushNotificationDetails));



// WEBPACK FOOTER //
// ./environments/genericEnv/scenes/PushNotification/details.js